/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StagingSummaryDto
 */
export interface StagingSummaryDto {
    /**
     * 
     * @type {number}
     * @memberof StagingSummaryDto
     */
    totalRows?: number;
    /**
     * 
     * @type {number}
     * @memberof StagingSummaryDto
     */
    creates?: number;
    /**
     * 
     * @type {number}
     * @memberof StagingSummaryDto
     */
    updates?: number;
    /**
     * 
     * @type {number}
     * @memberof StagingSummaryDto
     */
    skips?: number;
    /**
     * 
     * @type {number}
     * @memberof StagingSummaryDto
     */
    conflicts?: number;
    /**
     * 
     * @type {number}
     * @memberof StagingSummaryDto
     */
    failed?: number;
}

/**
 * Check if a given object implements the StagingSummaryDto interface.
 */
export function instanceOfStagingSummaryDto(value: object): value is StagingSummaryDto {
    return true;
}

export function StagingSummaryDtoFromJSON(json: any): StagingSummaryDto {
    return StagingSummaryDtoFromJSONTyped(json, false);
}

export function StagingSummaryDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): StagingSummaryDto {
    if (json == null) {
        return json;
    }
    return {
        
        'totalRows': json['totalRows'] == null ? undefined : json['totalRows'],
        'creates': json['creates'] == null ? undefined : json['creates'],
        'updates': json['updates'] == null ? undefined : json['updates'],
        'skips': json['skips'] == null ? undefined : json['skips'],
        'conflicts': json['conflicts'] == null ? undefined : json['conflicts'],
        'failed': json['failed'] == null ? undefined : json['failed'],
    };
}

export function StagingSummaryDtoToJSON(json: any): StagingSummaryDto {
    return StagingSummaryDtoToJSONTyped(json, false);
}

export function StagingSummaryDtoToJSONTyped(value?: StagingSummaryDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'totalRows': value['totalRows'],
        'creates': value['creates'],
        'updates': value['updates'],
        'skips': value['skips'],
        'conflicts': value['conflicts'],
        'failed': value['failed'],
    };
}

